module.exports = __webpack_public_path__ + "static/Burst_6-25b003cf7e27dfc2618a0182620d078d.jpg";